import { useTranslation } from 'react-i18next';
import { Box, Grid, IconButton, MenuItem } from '@mui/material';
import { ContactType, ControlledCheckbox, ControlledInput, ControlledSelect, IContact } from '../../../shared';
import { Close } from '@mui/icons-material';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

interface Props {
    field?: string;
    onRemoveContact: () => void;
}

export const ContactInputs: FC<Props> = ({ field, onRemoveContact }) => {
    const { t } = useTranslation();
    const prefix = field ? `${field}.` : '';
    const { getValues, setValue } = useFormContext();

    const handlePrimaryContactChange = () => {
        const index = getValues().contacts.findIndex((contact: IContact) => contact.primaryContact);
        if (index >= 0) setValue(`contacts.${index}.primaryContact`, false);
    };

    return (
        <Grid container spacing={2} width="inherit" alignItems="center">
            <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
                <ControlledSelect name={`${prefix}type`} label={t('typeLabel')}>
                    {Object.entries(ContactType).map(([key, value]) => (
                        <MenuItem value={value} key={value}>
                            {t(key)}
                        </MenuItem>
                    ))}
                </ControlledSelect>
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
                <ControlledInput name={`${prefix}data`} label={`${t('contactLabel')}`} sx={{ colSpan: 2 }} required />
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
                <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    <ControlledCheckbox
                        name={`${prefix}primaryContact`}
                        label={`${t('primaryContact')}`}
                        handleChange={handlePrimaryContactChange}
                    />

                    <IconButton aria-label="delete" onClick={onRemoveContact} size="large">
                        <Close />
                    </IconButton>
                </Box>
            </Grid>
        </Grid>
    );
};
